import React from "react";
import { NavLink } from "react-router-dom";
import $ from "jquery";

export default class PageTitle extends React.Component {
  render() {
    if (this.props.counttype) {
      console.log(this.props.counttype);
      if (this.props.counttype == "Active ") {
        setTimeout(function () {
          $("#btn_1").removeClass("btn-primary");
          $("#btn_1").addClass("btn-success custbtn");
          $("#btn_0").removeClass("btn-success custbtn");
          $("#btn_0").addClass("btn-primary");
        }, 500);
      } else if (this.props.counttype == "Inactive ") {
        setTimeout(function () {
          $("#btn_0").removeClass("btn-primary");
          $("#btn_0").addClass("btn-success custbtn");
          $("#btn_1").removeClass("btn-success custbtn");
          $("#btn_1").addClass("btn-primary");
        }, 500);
      }
    }

    return (
      <div className="row wrapper border-bottom white-bg page-heading">
        <div className="col-sm-4">
          <h2>{this.props.title}</h2>
          <ol className="breadcrumb">
            {this.props.bread.split("/").map((value, index) => {
              return (
                <li key={index}>
                  <a href="javascript:void(0);">{value}</a>
                </li>
              );
            })}
          </ol>
        </div>
        {this.props.Count != 0 && typeof this.props.counttype != "undefined" ? (
          <div className="col-sm-2">
            {" "}
            <h3 style={{ marginTop: "40px" }}>
              {" "}
              {this.props.counttype + " Count : " + this.props.Count}
            </h3>{" "}
          </div>
        ) : (
          <div className="col-sm-2"></div>
        )}
        {this.props.links ? (
          <div className="col-sm-6">
            <div className="title-action">
              {this.props.links.map((value, key) => {
                return (
                  <span>
                    <NavLink
                      className="btn btn-primary btn-rounded"
                      id={"btn_" + key}
                      to={value.link}
                    >
                      {value.name}
                    </NavLink>{" "}
                    &nbsp;
                  </span>
                );
              })}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/PageTitle.jsx